
<template >
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'70px'}" id="outermost">

        <van-nav-bar
            title="用户资料"
            left-text="返回"
            left-arrow
            style="background-color: #4263EB"
            @click-left="$router.push({name: 'common-reviewMe'})"
            id="topbar"
        />
        <div class="topDiv">

          <div style="height: 120px;width: 120px;border: 1px solid #CECECE ;border-radius: 50%;margin: 0px auto;margin-top: 30px">
            <img class="headImg" v-if="!userInfo.avatar"  src="@/assets/headImg.png"  style="width: 100%;height: 100%;border-radius: 50%;z-index: 444">
            <img class="headImg"  v-if="userInfo.avatar" :src="apiUrl + 'download/' + userInfo.avatar" @click="showAvatar(userInfo.avatar)" style="width: 100%;height: 100%;border-radius: 50%;z-index: 444"/>
<!--            <van-icon name="photograph" style="z-index: 555;float: right;margin-top: -15px" size="30" color="#4263EB"/>-->
          </div>
          <van-cell-group style="margin-top: 50px;height: 70px;">
            <div style="float: left;width: 20%;height: 100%;line-height: 90px;margin-left: 5%">
              <van-icon name="manager" size="35" color="#543AF8" />
            </div>
            <div style="float: left;width: 75%;height: 100%;line-height: 70px;font-size: 16px;font-weight: bold">
              {{userInfo.nname}}
            </div>

          </van-cell-group>
          <van-cell-group style="height: 70px;">
            <div style="float: left;width: 20%;height: 100%;line-height: 90px;margin-left: 5%">
              <van-icon name="phone" size="35" color="#27AE60" />
            </div>
            <div style="float: left;width: 75%;height: 100%;line-height: 70px;font-size: 16px;font-weight: bold">
              {{userInfo.mobile}}
            </div>

          </van-cell-group>
          <van-cell-group style="height: 70px;">
            <div style="float: left;width: 20%;height: 100%;line-height: 90px;margin-left: 5%">
              <van-icon name="comment" size="35" color="#F2994A" />
            </div>
            <div style="float: left;width: 75%;height: 100%;line-height: 70px;font-size: 16px;font-weight: bold">
              {{userInfo.email}}
            </div>

          </van-cell-group>
<!--            <van-cell-group>
                <van-field name="avatar" label="头像" input-align="right">
                  <template #input>
                    <img v-if="userInfo.avatar" class="headImg" :src="apiUrl + 'download/' + userInfo.avatar" @click="showAvatar(userInfo.avatar)"/>
                    <van-uploader v-else disabled/>
                  </template>
                </van-field>
            </van-cell-group>
            <van-cell-group>
                <van-field label="姓名" readonly :value="userInfo.nname" input-align="right"/>
            </van-cell-group>
            <van-cell-group>
                <van-field label="性别" readonly :value="userInfo.ssexName" input-align="right"/>
            </van-cell-group>
             <van-cell-group>
                <van-field label="手机号" readonly :value="userInfo.mobile" input-align="right"/>
            </van-cell-group>
            <van-cell-group>
                <van-field label="邮箱" readonly :value="userInfo.email" input-align="right"/>
            </van-cell-group>-->
<!--            <van-cell-group>-->
<!--                <van-field readonly v-if="userInfo.groupName" label="组别" :value="userInfo.groupName" input-align="right"/>-->
<!--                <van-field readonly v-else label="组别" value="无" input-align="right"/>-->
<!--            </van-cell-group>-->
        </div>
        <div style="position: fixed;bottom: 0px;width: 100%;">
<!--            <van-button block color="#1B75F6" native-type="button" @click="toModifyUser">修改</van-button>-->
        </div>
  </div>
</template>

<script>
    import $ from '@/fly'
    import { ImagePreview } from 'vant';
    import Setting from '@/setting';
    export default {
        name: 'common-userInfo',
        data () {
            return {
                clientHeight: window.screen.height,
                userInfo: {},
                apiUrl: Setting.apiBaseURL,
                projectInfo:{},
            }
        },

        methods: {
            showAvatar (id) {
                ImagePreview({
                    images: [
                        Setting.apiBaseURL + 'download/' + id
                    ],
                    closeable: true
                });
            },
            toModifyUser () {
                this.$router.push({ name: 'common-modifyUserInfo' });
            }
        },
        mounted () {
            $.get('user/' + this.$store.state.admin.user.info.username).then(res => {
                if (res.ssex === '0') {
                    res.ssexName = '男'
                } else if (res.ssex === '1') {
                    res.ssexName = '女'
                } else if (res.ssex === '2') {
                    res.ssexName = '保密'
                }
                this.userInfo = res;
            })
            this.projectInfo = JSON.parse(localStorage.getItem('projectInfo'))
        }
    }
</script>

<style lang="less" scoped>
    .topDiv{
        margin-top:20px;
    }
    .lableTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
        width:28%;
    }
    .starTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
    }
    .starTxt span{
        color: #FF6969;
        font-size: 30px;
        margin-right: 3px;
    }

    .typeDiv{
        padding:20px 30px;
        font-size: 28px;
    }
    .typeRow{
        padding-left:20px;
        border-left:6px solid #50C9FF;
    }
    .typeRow .van-col:nth-child(2){
        font-size: 0.38rem;
        font-weight: 400;
    }
    .typeItem{
        box-shadow: #f2f3f5 0px 0px 20px 1px;
    }
    .type-search {
        background-color: #EBEEF5;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 2vw 4vw;
        border-radius: 50px;
        padding:0 0 0 4vw;
    }
    .type-search button{
        border-radius: 0 50px 50px 0;
    }
    .search-icon {
      margin-left: 5px;
      font-size: 50px;
    }
    .searchInput {
      margin: 0 1.5vw;
      background-color: #F7F8FA;
      border: 0px;
      font-size: 14px;
      flex: 1;
      background:none;
      padding:15px;
    }
    .clear-icon {
        color: #999;
        font-size: 40px;
        margin-right:15px;
    }
    .van-cell{
        font-size: 0.37rem;
    }
    .van-radio{
        color: #666666;
    }
    .headImg{
      width: 160px;
      height: 160px;
      border-radius: 15px;
    }

</style>
